<template>
  <div class="in-box-wrapper">
    <!-- <el-card> -->
    <!-- 暂时去掉 -->
    <!-- <el-tabs v-model="activeTab">
        <el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in tabs" :key="index"></el-tab-pane>
      </el-tabs> -->
    <!-- <z-search
        ref="searchArea"
        :showNumCheck="false"
        v-model="params"
        :configs="options[activeTab]"
        @do-query="search"
        @do-reset="onReset"
      /> -->
    <!-- </el-card> -->
    <!-- <Google ref="facebook" :params="params" style="margin-top: 10px;"></Google> -->
    <Facebook ref="facebook" :params="params"></Facebook>
    <!-- <component :is="activeTab" :params="params" style="margin-top: 10px;" /> -->
  </div>
</template>
<script>
// import replied from './replied'
// import noplied from './noplied'
import Facebook from './facebook'
import Google from './google'
import { getSession, setSession } from '@/utils/storage'
export default {
  name: 'in-box',
  components: {
    Facebook,
    Google
    // noplied,
    // replied
  },
  data() {
    return {
      tabs: [{ label: 'Facebook', name: 'facebook', value: '1' }],
      params: {
        status: '',
        attachmentStatus: ''
      },
      activeTab: 'facebook',
      options: {
        facebook: [
          {
            key: 'accountId',
            label: '账号ID',
            searchType: 'input',
            componentData: {
              placeholder: 'Facebook账号ID',
              clearable: true
            }
          },
          {
            key: 'accountName',
            label: '账号名称',
            searchType: 'input',
            componentData: {
              placeholder: 'Facebook账号名称',
              clearable: true
            }
          },
          {
            key: 'shopId',
            label: '店铺',
            searchType: 'dict',
            componentData: {
              cache: false,
              dictKey: 'shop_id',
              placeholder: '店铺',
              filterable: true,
              clearable: true
            }
          }
        ]
      }
    }
  },

  mounted() {
    if (this.$router.query && this.$router.query.name) {
      this.activeTab = this.$router.query.name
    }
  },
  watch: {
    activeTab(tab) {
      console.log(tab, 'tab')
      this.params.status = this.tabs.find(item => item.name === tab).value || ''
      this.$refs[tab].search(this.params)
    }
  },
  methods: {
    onReset(params) {
      this.$refs[this.activeTab].init(params)
    },
    search(params) {
      this.$refs[this.activeTab].search(params)
    }
  }
}
</script>
<style lang="scss" scoped></style>
